import React from "react";
import styles from "./Spacer.module.less";

export default function Spacer(props: {
    children: React.ReactNode;
    size: keyof typeof styles
}) {
    return <div className={`${styles[props.size]}`}>{props.children}</div>;
}
